<template>
  <div style="overflow: hidden">
    <h2 class="bp_color">MY PIPELINE</h2>
    <kanban-board :stages="stages" :blocks="blocks" :config="config" :class="'kanban'" @update-block="updateBlock">
      <div v-for="stage in stages" :slot="stage" :key="stage">
        <h2>{{ stage }}</h2>
      </div>
      <div v-for="block in blocks" :slot="block.id" :key="block.id" :class="['pipeline_block', block.pipeline_opportunity_size.value]">
        <!--        <span v-if="block.status !== 'live' && block.status !== 'contract-sent' && block.status !== 'contract-signed'" class="handle">+</span>-->
        <!--        <div>-->
        <!--          <strong>id:</strong> {{ block.id }}-->
        <!--        </div>-->
        <div style="display: block">
          {{ block.company_name }}
          <button @click="show_record_company" class="btn orcaBtn greenBtn mb-2 mr-1 ml-1" data-toggle="tooltip" title="View Record"><i class="fas fa-eye"></i></button>
        </div>
      </div>
    </kanban-board>
  </div>
</template>

<script>
import vueKanban from 'vue-kanban'
import Vue from "vue";

Vue.use(vueKanban)

export default {
  name: "my_pipeline_detail",
  data() {
    return {
      stages: [
        {stage: 'cold', count: 0},
        {stage: 'warm', count: 0},
        {stage: 'hot', count: 0},
        {stage: 'live', count: 0},
        {stage: 'lapsed', count: 0}
      ],
      blocks: [],
      config: {
        // Don't allow blocks to be moved out of the approved stage
        accepts(block, target, source) {
          return false;
          // return source.dataset.status !== 'live' && source.dataset.status !== 'contract-sent' && source.dataset.status !== 'contract-signed'
          // && target.dataset.status !== 'live'  && target.dataset.status !== 'contract-sent' && target.dataset.status !== 'contract-signed'
        },
        // moves(block, target, handle) {
        //   return handle.classList.contains('handle');
        // }
      }
    }
  },
  beforeMount() {
    axios.get(this.crmApiPath + 'sales_service/pipeline/my_pipeline', {
      params: {
        user_id: this.$store.state.auth.me.id
      }
    }).then(res => {
      // console.log(res.data)
      this.blocks = res.data;
    })
  },
  methods: {
    updateBlock(id, status) {
      this.blocks.find(b => b.id === Number(id)).status = status;
    },
    show_record_company() {

    }
  }
}
</script>

<style scoped>

</style>
